<template>
   <div class='pay-way'>
       <div class="pay-content">
          <!-- 应付金额 -->
          <p>{{$t('bstext.bs65')}}</p>
          <div class="pay-account"><span>{{billInfo.currencySymbol}}</span>{{billInfo.amount | formatPrice}}</div>
       </div>
       <div class="pay-way-box">
          <!-- 请选择付款方式 -->
          <h2>{{$t('bstext.bs66')}}</h2>
          <div class="pay-way-card" v-for="item in payMethods" :key="item.key" @click="payMethodTab(item)">
             <span><i :class='[payMethodIcon[item.key]]'></i><span class="ml8">{{item.val}}</span></span><i :class='[payMethod==item.key?"bs-icon-selected":"bs-icon-no-selected"]'></i>
          </div>
       </div>
      <div class="btn-box">
         <!-- 下一步 -->
         <bs-button class="w100" @click="payOrder">{{$t('bstext.bs5')}}</bs-button>
      </div>
      <form ref="form" method="post"></form>
   </div>
</template>

<script>
const payMethodIcon={
   'CARD':'bs-icon-credit-card',
   'BANK':'bs-icon-bank',
   'VBANK':'bs-icon-virtual-account',
}
export default {
   data () {
      return {
         ono:this.$route.query.ono,
         billInfo:{},//账单信息
         payInfo:{},//支付信息
         payMethod:'CARD',
         payMethods:[],
         payMethodIcon:payMethodIcon,
      }
   },
   mounted() {
      this.payMethods=this.$t('bsstatus.payMethods')
      // 支付
      document.title = this.$t('bstext.bs67')
      this.getBillInfo()
   },
   methods: {
      payMethodTab(item){
         this.payMethod=item.key
      },
      // 获取账单详情
      getBillInfo(){
         this.$appApi.nativeLoading(true,'',0)
         let req ={
            ono:this.ono
         }
         this.$server.getBillInfo(req).then(res=>{
            let info =res.data
            this.billInfo=info
         }).finally(()=>{
            this.$appApi.nativeLoading(false,'',0)
         })
      }, 
      // 获取支付参数
      payOrder(){
         this.$appApi.nativeLoading(true,'',0)
         let req ={
            orderNo:this.ono,
            channel:'nicepay',
         }
         this.$server.payOrder(req).then(res=>{
            let info =res.data.nicepay
            this.payInfo=info
            this.handlePay()
         }).finally(()=>{
            this.$appApi.nativeLoading(false,'',0)
         })
      }, 
      handlePay() {
      let req = {
        'PayMethod': this.payMethod,
        'GoodsName': this.payInfo.goodsName,
        'Amt': this.payInfo.price,
        'MID': this.payInfo.merchantId,
        'Moid': this.payInfo.moid,
        'BuyerName': this.payInfo.buyerName,
        'BuyerEmail': this.payInfo.buyerEmail,
        'BuyerTel': this.payInfo.buyerTel,
        'ReturnURL': this.payInfo.returnUrl,
        'NpLang': 'EN',
        'GoodsCl': '1',
        'TransType': '0',
        'CharSet': 'utf-8',
        'ReqReserved': '',
        'EdiDate': this.payInfo.ediDate,
        'SignData': this.payInfo.signData,
        'VbankExpDate': '',
      };
      let form = this.$refs.form;
      // console.log(this.$refs.form.$el,'form')
      for (let reqKey in req) {
        this.setFormData(form, reqKey, req[reqKey]);
      }
      form.acceptCharset = 'euc-kr';
      form.action = 'https://web.nicepay.co.kr/v3/v3Payment.jsp';
      form.submit();
    },
    setFormData(f, key, value) {
      if (f[key]) {
        f[key].value = value;
      } else {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = value;
        f.appendChild(input);
      }
    },
   }
}
</script>

<style lang='less' scoped>
.pay-way{
   box-sizing: border-box;
   min-height: 100vh;
   padding: 20px;
   background: #F7F8FA;
   .pay-content{
      padding: 20px 0 45px;
      text-align: center;
      p{
         font-size: 16px;
         color: #8F95A3;
         line-height: 22px;
         margin-bottom: 12px;
      }
      .pay-account{
         font-size: 40px;
         font-weight: 600;
         color: #21242C;
         line-height: 32px;
         span{
            margin-right: 4px;
            font-size: 20px;
            color: #21242C;
            font-weight: 400;
            line-height: 28px;
         }
      }
   }
   .pay-way-box{
      h2{
         margin-bottom: 24px;
         font-size: 16px;
         font-weight: 600;
         color: #21242C;
         line-height: 22px; 
      }
      .pay-way-card{
         padding: 12px 16px;
         margin-bottom: 12px;
         background: #FFFFFF;
         border-radius: 2px;
         display: flex;
         justify-content: space-between;
         align-items: center;
         .ml8{
            margin-left: 8px;
         }
      }
   }
   .btn-box {
      box-sizing: border-box;
      position: absolute;
      bottom: 0;
      left: 0;
      padding: 40px 40px;
      width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/blueshark/battswap/pay/payway.vue